module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN320_841113016.72cb468d.png";